import { useTranslation } from 'react-i18next';
import { SupplierFullDtoIn } from '@/models/in/SupplierFullDtoIn';
import { SupplierApprovalStatus } from '@/models/common/ProjectStatus';
import userIcon from '@/assets/icons/user.svg';
import id2Icon from '@/assets/icons/id2.svg';
import selectedIcon from '@/assets/icons/selected-v.svg';
import styles from './ChooseSupplier.module.scss';

interface SupplierListItemProps {
  supplier: SupplierFullDtoIn;
  isSelected: boolean;
  onClick: (supplier: SupplierFullDtoIn) => void;
  /**
   * The approval to show, when it is not the supplier's own - its approval for the chosen project
   * (SPR-10302). Defaults to the supplier's own status.
   */
  approvalStatus?: SupplierApprovalStatus;
}

const SupplierListItem = ({ supplier, isSelected, onClick, approvalStatus = supplier.approvalStatus }: SupplierListItemProps) => {
  const { t } = useTranslation();
  return (
    <div className={`${styles.supplierListItem} ${isSelected ? styles.selected : ''}`} onClick={() => onClick(supplier)}>
      <div className={`${styles.innerContent} ${isSelected ? styles.selected : ''}`}>
        <div className={styles.details}>
          <div className={`${styles.itemContent} min-w-0 max-w-[200px]`}>
            <img src={userIcon} alt="Supplier" width={20} height={20} />
            <span className="body-lr-regular text-(--font-body-1) overflow-hidden text-ellipsis whitespace-nowrap">
              {supplier.name}
            </span>
          </div>
          <div className={styles.itemContentWithDivider}>
            <div className={styles.divider}></div>
            <div className={styles.itemContent}>
              <img src={id2Icon} alt="Tax ID" width={20} height={20} />
              <span className="body-lr-regular text-(--font-body-1)">
                {supplier.taxId}
              </span>
            </div>
          </div>
        </div>
        {/* HAT-1105: a supplier the office has not approved yet can still be paid; this says so
            instead of leaving a coordinator to wonder why it looks different from the rest. */}
        {approvalStatus === SupplierApprovalStatus.PendingApproval && (
          <span className={`${styles.pendingBadge} body-xs-regular`}>{t('projects.suppliers.status.PendingApproval')}</span>
        )}
        {isSelected && (
          <img src={selectedIcon} alt="Selected" width={20} height={20} />
        )}
      </div>
    </div>
  );
};

export default SupplierListItem;
